var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetail = function SvgRetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "retail_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#retail_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.587 0c8.907.456 14.338 10.274 9.735 18.078-4.532 7.696-15.657 7.888-20.44.336C-2.9 10.86 2.302.432 11.412 0h1.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.482 7.564V6.486c0-.42-.324-1.055-.588-1.367-1.115-1.319-3.213-1.103-4.064.396-.36.635-.335 1.342-.323 2.05h-2.47V18.52h9.938V7.564H14.47h.011Zm-.72-.036-.048.048H10.25V6.474c0-.576.695-1.247 1.21-1.403 1.02-.312 2.29.444 2.29 1.546v.923l.012-.012Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRetail as ReactComponent };